import { STORY_STATUSES } from 'types';

export const STATUS_FILTERS_OPTIONS = Object.keys(STORY_STATUSES).map((key) => {
  const statusKey = key as keyof typeof STORY_STATUSES;
  return {
    value: STORY_STATUSES[statusKey],
    label: STORY_STATUSES[statusKey][0].toUpperCase() + STORY_STATUSES[statusKey].slice(1),
  };
});

export const EXPIRATION_FILTERS_OPTIONS = [
  {
    value: true,
    label: 'Expiring',
  },
  {
    value: false,
    label: 'Non expiring',
  },
];
